import { Box, Card, CardBody, CardHeader, Text, TextInput } from "grommet"
import { Link } from "grommet-icons"
import { useSettingsContext } from "./SettingsContextProvider";

export const OverlayLinkCard = () => {

    const { settingsContext } = useSettingsContext();

    return (
        <Box>
            <Card background={'brand'}>
                <CardHeader pad={{ top: 'medium', left: 'medium', right: 'medium' }}><Box direction="row" gap={'xsmall'} align="center"><Link/><Text>OBS Browser Source URL</Text></Box></CardHeader>
                <CardBody gap={'small'} align="center">
                    {settingsContext && <TextInput value={`${process.env.REACT_APP_FE_URL}/overlay?intensity=${settingsContext.intensity}&fallSpeed=${settingsContext.fallSpeed}&windDirection=${settingsContext.windDirection}&snowSize=${settingsContext.snowSize}&enableSnowDrifts=${settingsContext.enableSnowDrifts}&maxDriftHeight=${settingsContext.maxDriftHeight}&meltSimulation=${settingsContext.meltSimulation}&meltSpeed=${settingsContext.meltSpeed}&weatherSim=${settingsContext.weatherSim}`} readOnlyCopy />}
                    <Text size="xsmall">Add a Browser Source in OBS and paste this URL.</Text>
                </CardBody>
            </Card>
        </Box>
    )
}